var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlueShip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 39,
    viewBox: "0 0 45 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.5455 19.7922C39.9234 19.5228 39.9064 18.9538 39.5131 18.7075L30.5547 13.0992L5.50931 14.5047C5.17786 14.5233 4.91391 14.7902 4.89761 15.1233L4.6552 20.075C4.65195 20.1413 4.65375 20.2077 4.66058 20.2737L5.17753 25.2721C5.21179 25.6033 5.48916 25.8554 5.82071 25.8566L30.9083 25.9474L39.5455 19.7922Z",
    fill: "#459FFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueShip);
export default __webpack_public_path__ + "static/media/blueShip.b0fccd2e080e3e421f58204c04fca5be.svg";
export { ForwardRef as ReactComponent };